import { EnvConfigBrand } from '@core/config-models';

import type { PartialFileName } from './interfaces';

/**
 * Dutch ISO language code
 */
export const dutchIsoLanguage = 'nl-NL';

/**
 * Default path to the non-brand-specific json translation file
 */
export const jsonTranslationName = 'nl-NL';

/**
 * Default paths to the brand-specific json translation files
 */
export const brandJsonTranslationNames: Record<
  EnvConfigBrand,
  PartialFileName
> = {
  [EnvConfigBrand.ED]: 'ed.nl-NL',
  [EnvConfigBrand.Essent]: 'essent.nl-NL',
};

/**
 * Default namespace for the translations
 */
export const appNamespace = 'app';
export const appButtonsNamespace = `${appNamespace}.buttons`;
export const appLabelsNamespace = `${appNamespace}.labels`;
export const appPrepositionsNamespace = `${appNamespace}.prepositions`;
